/** Host API PostHog EU (serveur Nitro / posthog-node). */
export const POSTHOG_EU_API_HOST: string = 'https://eu.i.posthog.com'

/** UI PostHog EU (toolbar, replays). */
export const POSTHOG_EU_UI_HOST: string = 'https://eu.posthog.com'

/**
 * Proxy PostHog first-party : collecte d'événements produit PrePeers.
 * Route Nitro : `server/routes/prepeers/events/[...path].ts`
 * Éviter `/ingest`, `/analytics`, `/posthog` (listes uBlock/EasyPrivacy).
 */
export const POSTHOG_PROXY_PATH: string = '/prepeers/events'

/** Sous-ensemble typé de posthog-js (évite `null` sur `ui_host` incompatible avec Nuxt runtimeConfig). */
export interface PrePeersPostHogClientConfig {
  api_host: string
  ui_host: string
  person_profiles: 'always' | 'identified_only' | 'never'
  opt_out_capturing_by_default: boolean
  capture_pageview: boolean
  capture_pageleave: boolean
  autocapture: boolean
  capture_exceptions: boolean
  session_recording: {
    maskAllInputs: boolean
  }
}

/** Options posthog-js côté navigateur. */
export const POSTHOG_CLIENT_CONFIG: PrePeersPostHogClientConfig = {
  api_host: POSTHOG_PROXY_PATH,
  ui_host: POSTHOG_EU_UI_HOST,
  person_profiles: 'always',
  opt_out_capturing_by_default: true,
  capture_pageview: true,
  capture_pageleave: true,
  autocapture: true,
  capture_exceptions: true,
  session_recording: {
    maskAllInputs: true,
  },
}
